import { render, staticRenderFns } from "./Health.vue?vue&type=template&id=3c1e776b&scoped=true&"
import script from "./Health.vue?vue&type=script&lang=ts&"
export * from "./Health.vue?vue&type=script&lang=ts&"
import style0 from "./Health.vue?vue&type=style&index=0&id=3c1e776b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1e776b",
  null
  
)

export default component.exports